module.exports = __webpack_public_path__ + "static/media/but.11814111.svg";